import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { CheckboxWithLabel } from '@grandvisionhq/forms';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';
import { getFacetOptionLabel } from '../../utils/get-facet-option-label.js';

const Label = ({ icon , label , count  })=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("span", {
        className: "refinement-item__value",
        "data-t": "facet-item-value"
    }, icon && /*#__PURE__*/ React.createElement(Icon, {
        name: icon
    }), " ", label), /*#__PURE__*/ React.createElement("span", {
        className: "refinement-item__count"
    }, count))
;
const RefinementItem = ({ item , facet , onRefine , onChange  })=>{
    const intl = useIntl();
    const { icon , label  } = React.useMemo(()=>getFacetOptionLabel(facet, item.label, intl)
    , [
        facet,
        item,
        intl
    ]);
    const handleChange = React.useCallback(()=>{
        onRefine(item.value);
        onChange && onChange();
        DataLayer.pushEvent(createFilterApplied(intl.getLabel(facet.labelKey || ''), item.value));
    }, [
        item,
        onChange,
        onRefine
    ]);
    return /*#__PURE__*/ React.createElement("span", {
        className: "refinement-item"
    }, /*#__PURE__*/ React.createElement(CheckboxWithLabel, {
        className: "refinement-item__checkbox",
        checked: item.isRefined,
        value: item.label,
        onChange: handleChange,
        label: /*#__PURE__*/ React.createElement(Label, {
            count: item.count,
            label: label,
            icon: icon
        })
    }));
};
const createFilterApplied = (facetLabel, option)=>{
    const optionValue = option.length > 0 ? option.join(', ') : null;
    return {
        event: 'filter_applied',
        filter_type: facetLabel,
        filter_value: optionValue
    };
};

export { RefinementItem as default };
//# sourceMappingURL=RefinementItem.js.map
